if (!window.Eurus.loadedScript.has("product-tabs.js")) {
  window.Eurus.loadedScript.add("product-tabs.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xProductTabs", () => ({
        open: 0,
        openMobile: false,
        tabActive: '',
        setTabActive() {
          const tabActive = this.$el.dataset.tabtitle;
          this.tabActive = tabActive;
        }
      }));
    });
  });

function initTabScroll() {
  const tabItems = document.querySelectorAll('.tab-item');
  const productTab = document.getElementById('product-tab');
  if (!productTab || !tabItems.length) return;

  tabItems.forEach((tabItem) => {
    if (tabItem._tabScrollInit) return;
    tabItem._tabScrollInit = true;
    tabItem.addEventListener('click', function() {
      setTimeout(function() {
        const header = document.querySelector('.section-header');
        const offset = header ? header.offsetHeight : 0;
        const top = productTab.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }, 100);
    });
  });
}

  document.addEventListener('DOMContentLoaded', () => {
    initTabScroll();
    setTimeout(initTabScroll, 1000);
  });
}
